import { toContact, toContacts } from './serializers'
import { AddOptions } from 'components/ideal-core-ui'

const Contact = () => {
  return (
    <AddOptions
      texts={{
        title: 'Contact Status',
        subtitle: 'Contact Status Options',
        description:
          'Contact status is meant to allow you to differentiate between contacts who are active and the ones who moved to another company or retired.'
      }}
      url="/v1/contact-status"
      toItemSerializer={toContact}
      toItemsSerializer={toContacts}
      itemsType="contacts"
    />
  )
}

export default Contact
